/**
 * The licence state a nurse card's save sends as `jurisdiction`.
 *
 * The Bio cards' one "State" field (CurrentNurseBio, PatientNurseBio,
 * AccountNurseBio, GridNurseBio) and the nurse card modal's are the person's
 * ADDRESS - staffRows' `state`, the API's `users.state`. Main kept one
 * `nurses.state` column for both the address and the licence state, so its
 * cards sent that one field as both. The port keeps two facts: the licence's
 * own state travels on the row as `licensestate` (bridgeMap licenceAliases),
 * and accountBridge.nurseUpdateBody sends `jurisdiction` as the licence's
 * `license_state`. Sent from the State field, every card save moved the state
 * licence to the person's home state - to the API another licence, so what
 * Nursys verified was dropped (and a 409 when someone else holds that number
 * there).
 *
 *  - The save (InternalUpdateNurse): the licence's own state, or none. No card
 *    has a licence-state field, so a card save never changes it.
 *  - The Nursys enrolment (Add_Nurse): the licence's own state. Only for a
 *    licence with none on file, the card's State - the one state the card
 *    has, as main sent it - because an enrolment needs a jurisdiction.
 */
export function licenceJurisdiction(row) {
  return String((row && (row.licensestate ?? row.licenseState)) || '').trim();
}

export function enrolmentJurisdiction(row, cardState) {
  return licenceJurisdiction(row) || String(cardState || '').trim();
}

export default { licenceJurisdiction, enrolmentJurisdiction };
